import { render, staticRenderFns } from "./layout5-comp1.vue?vue&type=template&id=260165aa&"
import script from "./layout5-comp1.vue?vue&type=script&lang=js&"
export * from "./layout5-comp1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports